const features = [
  {
    id: 1,
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '整合香蕉视频、红桃视频、蜜桃视频、樱花视频等热门平台资源，一个入口看遍全网好片，告别多平台切换的烦恼。',
  },
  {
    id: 2,
    icon: 'ri-hd-line',
    title: '超清画质',
    desc: '全站支持高清播放，采用领先的视频加速技术，加载快、不卡顿，给你丝滑流畅的观影体验。',
  },
  {
    id: 3,
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '内容团队 7×24 小时不间断更新，热门榜单、最新上线实时同步，确保你每天打开都有新鲜内容可看。',
  },
  {
    id: 4,
    icon: 'ri-shield-user-line',
    title: '安全私密',
    desc: '无需注册即可观看，无广告弹窗干扰，严格保护用户隐私。全站 HTTPS 加密传输，安心浏览每一刻。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">平台优势</h2>
        <p className="section-subtitle">为什么千万宅男选择我们？四大核心优势告诉你答案</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-10">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center group hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}